import React from 'react';

import { IconProps } from './types';

export const QuestionMarkIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="30"
        viewBox="0 0 30 30"
        width="30"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M15 0C6.73077 0 0 6.73077 0 15C0 23.2692 6.73077 30 15 30C23.2692 30 30 23.2692 30 15C30 6.73077 23.2692 0 15 0ZM15 2.30769C22.0222 2.30769 27.6923 7.97776 27.6923 15C27.6923 22.0222 22.0222 27.6923 15 27.6923C7.97776 27.6923 2.30769 22.0222 2.30769 15C2.30769 7.97776 7.97776 2.30769 15 2.30769ZM15.7061 6.92608C15.4237 6.92007 15.1472 6.94111 14.8768 6.99219C13.2662 7.28365 11.9471 8.53666 11.6196 10.1532C11.5204 10.5649 11.6556 10.9946 11.9681 11.277C12.2806 11.5595 12.7224 11.6496 13.119 11.5114C13.5186 11.3732 13.8101 11.0306 13.8792 10.616C14.0655 9.69652 14.9339 9.02344 16.0246 9.28486C16.8389 9.48017 17.3047 10.1352 17.3047 11.0517C17.3047 12.1394 16.8179 12.6983 16.0126 13.6268C15.2043 14.5553 14.1016 15.7933 13.8552 17.7404C13.774 18.3714 14.2218 18.9513 14.8558 19.0294C15.4868 19.1106 16.0637 18.6629 16.1448 18.0319C16.3041 16.7819 16.9321 16.0877 17.7554 15.1412C18.5757 14.1917 19.6124 12.9327 19.6124 11.0517C19.6124 9.21274 18.4255 7.49099 16.5655 7.04327C16.277 6.97416 15.9886 6.9351 15.7061 6.92608ZM15 20.7692C14.363 20.7692 13.8462 21.2861 13.8462 21.9231C13.8462 22.5601 14.363 23.0769 15 23.0769C15.637 23.0769 16.1538 22.5601 16.1538 21.9231C16.1538 21.2861 15.637 20.7692 15 20.7692Z"
          fill={color}
        />
      </svg>
    );
  },
);
